import { useEffect, useState } from "react";
import { api } from "../../api";
import { fmtDateTime } from "../../lib/format";
import { SectionHeading, EmptyState } from "../../components/ui";

// 既知 action の日本語ラベル。未登録の action は raw code をそのまま表示。
const ACTION_LABELS: Record<string, string> = {
  "auth.login": "ログイン",
  "auth.logout": "ログアウト",
  "auth.password_reset.request": "パスワード再設定 要求",
  "auth.password_reset.confirm": "パスワード再設定 完了",
  "member.hearing.complete": "ヒアリング完了",
  "event.apply": "イベント申込",
  "event.cancel": "イベント申込取消",
  "event.checkin.qr": "QR 受付",
  "event.checkin.manual": "手動受付",
  "admin.member.status_change": "会員ステータス変更",
  "admin.event.create": "イベント作成",
  "admin.event.update": "イベント更新",
  "admin.content.create": "コンテンツ作成",
  "admin.notice.create": "お知らせ作成",
  "admin.notice.update": "お知らせ更新",
  "admin.upload": "画像アップロード",
  "admin.upload_pdf": "PDF アップロード",
  "payment.webhook.stub": "決済 webhook (stub)",
  // LINE 連携 (Phase 1 / 2)
  "line.link.created": "LINE 連携成立",
  "line.link.revoked_by_user": "LINE 連携解除 (会員)",
  "line.link.revoked_by_unfollow": "LINE 連携解除 (友だち削除)",
  "line.link.revoked_by_admin": "LINE 連携解除 (管理)",
  "line.webhook.signature_failed": "LINE Webhook 署名失敗",
  "line.reminder.manual_sent": "LINE リマインダー手動送信",
};

interface Row {
  id: string;
  actorUserId: string | null;
  actorRole: string | null;
  action: string;
  resourceType: string | null;
  resourceId: string | null;
  createdAt: string;
}

export function AdminAuditPage() {
  const [items, setItems] = useState<Row[]>([]);
  useEffect(() => {
    api.get<{ items: Row[] }>("/admin/audit-logs").then((r) => setItems(r.items));
  }, []);
  return (
    <div>
      <SectionHeading level={2}>監査ログ</SectionHeading>
      {items.length === 0 ? (
        <EmptyState title="監査ログはまだありません" />
      ) : (
      <div className="overflow-x-auto">
      <table className="w-full text-xs border border-black/10">
        <thead className="bg-black/5 text-left">
          <tr>
            <th className="p-2">時刻</th>
            <th className="p-2">アクター</th>
            <th className="p-2">アクション</th>
            <th className="p-2">リソース</th>
          </tr>
        </thead>
        <tbody>
          {items.map((r) => (
            <tr key={r.id} className="border-t border-black/10 font-mono">
              <td className="p-2">{fmtDateTime(r.createdAt)}</td>
              <td className="p-2">{r.actorUserId ?? "-"}</td>
              <td className="p-2">
                {ACTION_LABELS[r.action] ?? r.action}
                {ACTION_LABELS[r.action] && (
                  <span className="ml-2 text-tora-ink/40 text-[10px]">
                    {r.action}
                  </span>
                )}
              </td>
              <td className="p-2">
                {r.resourceType}/{r.resourceId ?? "-"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
      )}
    </div>
  );
}
